import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { motion } from 'framer-motion';
import { CheckCircle, AlertTriangle, Loader } from 'lucide-react';

export default function PaymentCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('status');

    if (status === 'success') {
      toast.success('Ödeme başarılı! Yönlendiriliyorsunuz...', {
        duration: 5000,
      });
    } else {
      toast.error('Ödeme başarısız oldu veya iptal edildi.', {
        duration: 5000,
      });
    }

    // Güvenli yönlendirme: iframe içinde de çalışacak şekilde üst pencereye zorla
    const redirectToBrandSelector = () => {
      try {
        if (window.top && window.top !== window.self) {
          window.top.location.href = '/brand-selector';
          return;
        }
      } catch (_) {
        // Cross-origin erişimi engelliyse normal navigate'e düş
      }
      navigate('/brand-selector');
    };

    // Backend callback'in tamamlanması için kısa bekleme ve ardından yönlendirme
    const t1 = setTimeout(redirectToBrandSelector, 2000);
    // Ek güvenlik için ikinci bir fallback yönlendirme
    const t2 = setTimeout(redirectToBrandSelector, 6000);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };

  }, [location, navigate]);

  const status = new URLSearchParams(location.search).get('status');

  const content = {
    success: {
      icon: <CheckCircle className="w-16 h-16 text-green-500" />,
      title: 'Ödeme Başarılı!',
      message: 'Aboneliğiniz başarıyla aktif edildi. Brand selector sayfasına yönlendiriliyorsunuz...'
    },
    failed: {
      icon: <AlertTriangle className="w-16 h-16 text-red-500" />,
      title: 'Ödeme Başarısız',
      message: 'Ödeme işlemi başarısız oldu veya iptal edildi. Brand selector sayfasına yönlendiriliyorsunuz...'
    },
    default: {
      icon: <Loader className="w-16 h-16 text-gray-500 animate-spin" />,
      title: 'Ödeme Durumu Kontrol Ediliyor...',
      message: 'Lütfen bekleyin, ödeme durumunuz doğrulanıyor.'
    }
  };

  const currentContent = content[status] || content.default;

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center p-8 bg-white shadow-xl rounded-2xl max-w-md"
      >
        <div className="flex justify-center mb-6">
          {currentContent.icon}
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-3">{currentContent.title}</h1>
        <p className="text-gray-600">{currentContent.message}</p>
      </motion.div>
    </div>
  );
} 